import HelpIcon from 'dashboard/components-lib/HelpIcon';
import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { CaseAnalyticsResolutionTimes } from 'dashboard/models/case-analytics';
import CaseResolutionTimesChart from 'dashboard/views/DashboardCaseAnalyticsProductivityView/CaseResolutionTimesChart';
import Card from 'design-system/components/Card';

export interface CaseResolutionCardProps extends CaseAnalyticsResolutionTimes {
  loading: boolean;
}

const CaseResolutionCard = ({ loading, data, domain, period }: CaseResolutionCardProps) => {
  return (
    <Card>
      <Card.Body>
        <Card.Title id='case-analytics-productivity__case-resolution-card--title'>
          Resolution time
          <HelpIcon popoverWidth={335}>
            Resolution time is the amount of time that has passed between a case being created and
            it being resolved.
          </HelpIcon>
        </Card.Title>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <CaseResolutionTimesChart data={data} domain={domain} period={period} />
        )}
      </Card.Body>
    </Card>
  );
};

export default CaseResolutionCard;
